var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestInprogress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.62,
    height: 32,
    viewBox: "0 0 23.62 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "waiting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.68,20.79C15.4,18,13.95,17.52,13.95,16s1.46-2,4.74-4.79,2.49-7.56,2.49-7.56H2.45S1.66,8.42,4.93,11.21,9.67,14.48,9.67,16s-1.46,2-4.74,4.79-2.49,7.56-2.49,7.56H21.17S22,23.58,18.68,20.79Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 28.37,
    width: 23.62,
    height: 3.63,
    rx: 1.82,
    ry: 1.82,
    fill: "#904e39"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.62,
    height: 3.63,
    rx: 1.82,
    ry: 1.82,
    fill: "#904e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47,25.43A4.41,4.41,0,0,1,6.84,23c0.91-.78,1.66-1.35,2.32-1.86a12.81,12.81,0,0,0,2.44-2.23H12a12.81,12.81,0,0,0,2.44,2.23c0.66,0.51,1.41,1.08,2.32,1.86a4.4,4.4,0,0,1,1.37,2.43H5.47Z",
    fill: "#ef5551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,8a3.78,3.78,0,0,0,.82,1c0.91,0.78,1.66,1.35,2.32,1.86a12.81,12.81,0,0,1,2.44,2.23H12a12.81,12.81,0,0,1,2.44-2.23c0.66-.51,1.41-1.08,2.32-1.86a3.79,3.79,0,0,0,.82-1H6Z",
    fill: "#ef5551"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.68,20.79C15.4,18,13.95,17.52,13.95,16s1.46-2,4.74-4.79,2.49-7.56,2.49-7.56H11.81V28.35h9.36S22,23.58,18.68,20.79Z",
    fill: "#010101",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8,0h-10V3.63h10A1.82,1.82,0,0,0,21.8,0Z",
    fill: "#010101",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8,28.37h-10V32h10A1.82,1.82,0,0,0,21.8,28.37Z",
    fill: "#010101",
    opacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestInprogress);
export default __webpack_public_path__ + "static/media/request_inprogress.2a1f96ae38e51aa28ffb91fc89baa120.svg";
export { ForwardRef as ReactComponent };